import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { SimpleNavigation } from '../components/form/FormNavigation';
import { useNavigation } from '../store/formStore';

export function WelcomeStep() {
  const { goToNextStep } = useNavigation();
  
  return (
    <div className="max-w-2xl mx-auto">
      <Card className="text-center">
        <CardHeader>
          <div className="text-6xl mb-4">🤗</div>
          <CardTitle className="text-2xl text-primary-600">
            Bonjour et bienvenue chez Yelloan
          </CardTitle>
        </CardHeader>
        
        <CardContent>
          <p className="text-neutral-600 text-lg mb-6">
            Je suis Yellobot et je vais vous aider à faire votre demande de financement 
            en quelques minutes
          </p>
          
          <div className="bg-primary-50 border border-primary-200 rounded-lg p-4 mb-6">
            <h3 className="font-semibold text-primary-800 mb-2">
              Votre demande en 5 étapes simples :
            </h3>
            <ul className="text-sm text-primary-700 space-y-1 text-left">
              <li>• Simulation de votre projet</li>
              <li>• Informations personnelles</li>
              <li>• Adresse</li>
              <li>• Vérification et récapitulatif</li>
              <li>• Soumission de votre dossier</li>
            </ul>
          </div>
          
          <div className="text-sm text-neutral-500 mb-8">
            ⏱️ Temps estimé : <strong>5-7 minutes</strong>
          </div>
          
          <SimpleNavigation
            onContinue={goToNextStep}
            continueText="Commencer ma demande"
          />
        </CardContent>
      </Card>
    </div>
  );
}